import React from 'react';
import { useNavigate } from 'react-router-dom';

const timeline = [
  { year: '2015', event: 'Company Founded' },
  { year: '2017', event: 'Expanded to National Coverage' },
  { year: '2019', event: 'Opened Regional Offices' },
  { year: '2022', event: 'Reached 500+ Successful Placements' },
  { year: '2025', event: 'Industry Leader in Construction Recruitment' },
];

const values = [
  { icon: '🎯', title: 'Integrity', desc: 'Operating with strong moral and ethical principles in every placement and partnership.' },
  { icon: '🤝', title: 'Partnership', desc: 'If you want to walk fast, walk alone. If you want to walk far, walk together.' },
  { icon: '🌟', title: 'Excellence', desc: 'We see potential in difference and strive for the perfect match every time.' },
  { icon: '⚡', title: 'Trust', desc: 'Because the handshake still matters in construction.' },
  { icon: '⚖️', title: 'Fairness', desc: 'Nobody is left out — from apprentices to executives.' },
  { icon: '🔒', title: 'Compliance', desc: 'Safety, legality, and worker welfare at the heart of everything we do.' },
];

const accreditations = [
  'Association of Labour Providers (ALP)',
  'CITB Member',
  'REC Member',
  'Investors in People',
  'ISO 9001 Certified',
  'Modern Slavery Act Compliant',
  'Stronger Together',
];

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <h1>About Horizon Recruitment</h1>
          <p>Your trusted construction recruitment partner since 2015</p>
          <div className="breadcrumb">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
            <span>/</span>
            <span style={{ color: 'rgba(255,255,255,0.9)' }}>About Us</span>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'center' }}>
            <div>
              <h2>Our Story</h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                Founded with a vision to transform construction recruitment in the UK,
                Horizon Recruitment Ltd has grown to become a trusted partner for both
                employers and skilled professionals across the industry.
              </p>
              <p>
                Our success is built on deep sector knowledge, strong relationships,
                and an unwavering commitment to quality. Today, we're proud to work
                with leading construction companies, civil contractors, and specialist
                builders, helping them find the skilled professionals who turn
                blueprints into reality.
              </p>
              <p>
                Our team brings over 100 years of combined construction and recruitment
                experience, ensuring every placement is the right fit for both parties.
              </p>
            </div>
            <div style={{
              background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%)',
              borderRadius: 'var(--radius-xl)',
              padding: '60px 40px',
              textAlign: 'center',
              color: 'var(--white)',
            }}>
              <div style={{ fontSize: '4rem', marginBottom: '15px' }}>🏗️</div>
              <h3 style={{ color: 'var(--white)', fontSize: '1.8rem' }}>10+ Years</h3>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem', margin: 0 }}>
                Of Construction Recruitment Excellence
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section-alt">
        <div className="container">
          <div className="section-header">
            <h2>Our Journey</h2>
            <p>A decade of growth, partnerships, and industry leadership.</p>
          </div>
          <div className="timeline">
            {timeline.map((t, i) => (
              <div className="timeline-item" key={i}>
                <div className="timeline-dot" />
                <div className="timeline-content">
                  <div className="timeline-year">{t.year}</div>
                  <p style={{ margin: 0, fontWeight: 500 }}>{t.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="section-dark">
        <div className="container" style={{ textAlign: 'center', maxWidth: '800px' }}>
          <h2 style={{ color: 'var(--white)' }}>Our Mission</h2>
          <p style={{ fontSize: '1.3rem', lineHeight: '1.8', color: 'rgba(255,255,255,0.9)', fontStyle: 'italic' }}>
            "To connect exceptional construction talent with leading projects
            across the UK, building lasting partnerships that drive industry success."
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Our Core Values</h2>
            <p>The principles that guide every decision we make.</p>
          </div>
          <div className="grid grid-3">
            {values.map((v, i) => (
              <div className="value-card" key={i}>
                <div className="value-icon">{v.icon}</div>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Accreditations */}
      <section className="section-alt">
        <div className="container">
          <div className="section-header">
            <h2>Accreditations & Memberships</h2>
            <p>Certified, compliant, and committed to industry best practice.</p>
          </div>
          <div className="accreditation-grid">
            {accreditations.map((a, i) => (
              <div className="accreditation-badge" key={i}>{a}</div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <h2>Want to Join Our Team?</h2>
          <p>We're always looking for talented recruitment professionals.</p>
          <button className="btn btn-secondary btn-lg" onClick={() => navigate('/contact')}>
            Get in Touch
          </button>
        </div>
      </section>
    </div>
  );
}
